import React, { useState, useEffect, useRef } from "react";

import './style.scss';

import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import Select from "~components/Form/components/Select";
import Loader from "~components/Form/components/Loader";
import InputField from "~components/Form/components/InputField";
import MaskedInput from "react-text-mask";
import mask from "~services/utils/mask";
import * as yup from "yup";
import { InfoArrow, ModalClosed, ModalSuccess } from "~misc/icons";
import useModalInfosAdicionais from "~pages/Simulators/hooks/useModalInfosAdicionais";
import { useEnviarAprovacao } from "../../hooks/useSimulatorsQuery";
import usePrazoPagamento from "~/fetchs/usePrazoPagamento";
import useMotivo from "~/fetchs/useMotivo";
import useSimulation from "../../hooks/useSimulation";
import useDefaultFetch from "~/fetchs/useDefaultFetch";
import { useGetSimulacoes } from "~/hooks/useSincronizacao";
import useHeader from "~/components/Header/hooks/useHeader";

const ModalInfosAdicionais = ({ isOpen, onClose, onConfirm, onErrorResponse, simulacao }) => {
  const { dateMask } = mask();

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});

  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]" : "hidden";
  const overlayClasses = isOpen ? "fixed inset-0 bg-black opacity-50 " : "hidden";
  const { initial, validation } = useModalInfosAdicionais()

  const formikRef = useRef();

  const { onChangeMotivo, motivoSelect, optionMotivos } = useMotivo({ formikRef });
  const { onChangePrazoPagamento, prazoPagamentoSelect } = usePrazoPagamento(formikRef);

  const handleChangePrazo = (e) => {
    onChangePrazoPagamento(e);

    const value = e.value;
    const startDate = new Date();
    const finalDate = new Date();

    if (value != "personalizado") {
      finalDate.setDate(finalDate.getDate() + (value.days || 0))
      finalDate.setMonth(finalDate.getMonth() + (value.months || 0))
      finalDate.setFullYear(finalDate.getFullYear() + (value.years || 0))
    }

    let startDateString = [
      startDate.getDate().toString().padStart(2, '0'),
      (startDate.getMonth() + 1).toString().padStart(2, '0'),
      startDate.getFullYear(),
    ].join("/");

    let finalDateString = [
      finalDate.getDate().toString().padStart(2, '0'),
      (finalDate.getMonth() + 1).toString().padStart(2, '0'),
      finalDate.getFullYear(),
    ].join("/")

    formikRef.current.setFieldValue("dataInicioVigencia", startDateString);
    formikRef.current.setFieldValue("dataFimVigencia", finalDateString);
  }

  const handleChangeDates = (e) => {
    onChangePrazoPagamento({ label: "Pesonalizado", value: "personalizado" });
  }

  const optionPrazosPagamento = [
    { label: "1 Mês", value: { months: 1, } },
    { label: "3 Meses", value: { months: 3 } },
    { label: "6 Meses", value: { months: 6 } },
    { label: "1 Ano", value: { years: 1 } },
    { label: "Pesonalizado", value: "personalizado" },
  ];

  const [enabled, setEnabled] = useState(null);

  const { processLastFetchTime } = useHeader();
  const { refetching } = useDefaultFetch({
    useGet: useGetSimulacoes,
    table: "simulacoes",
    enabled: enabled,
    processLastFetchTime
  });

  const onSaveSuccess = (data) => {
    setFormValues({ ...formValues, simulacaoId: data?.id ?? simulacao?.simulacaoId });

    if (!enabled) setEnabled(true);
    else refetching();
  }
  const onSaveError = () => setLoading(false);
  const { handleSubmit: salvarSimulacao } = useSimulation({ simulacao, onSuccess: onSaveSuccess, onError: onSaveError });

  const handleSubmit = (values) => {
    try {
      if (Object.entries(values).length > 0) {
        setLoading(true);
        setFormValues(values)
        salvarSimulacao();
      }
    } catch (e) {
      setLoading(false);
    }
  }
  const onSuccess = (data) => {
    setLoading(false);
    onConfirm(data);
  }
  const onError = (data) => {
    onErrorResponse(data);
    setLoading(false);
  }
  const enviarAprovacao = useEnviarAprovacao(formValues, onSuccess, onError);

  useEffect(() => {
    if (formValues?.simulacaoId) {
      enviarAprovacao();
    }
  }, [formValues]);

  const [caracteres, setCaracteres] = useState("");
  const maxlenght = 200;

  return (
    <Formik
      initialValues={initial}
      validationSchema={validation}
      innerRef={formikRef}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, ...rest }) => (
        <Form className={`modal-simulators-infos-adicionais ${modalClasses}`}>
          <div className="fixed inset-0 flex items-center justify-center">
            <div className="bg-white px-14 pt-10 pb-4 rounded-[20px] shadow-lg  relative z-40 ">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                >
                  <ModalClosed />
                </button>
              </div>
              <Text fontSize="2xl" className="font-bold text-center mx-auto" maxWidth="300px" mb="4">
                Informações adicionais
              </Text>

              <div
                className={`relative flex flex-col  max-w-[450px] mx-auto border-t pt-8 ${loading && "spinner__form-active"
                  }`}
              >

                <Select
                  label={<>Informe o <b className="px-[.2rem]">prazo de vigência</b> das negociações solicitadas:</>}
                  options={optionPrazosPagamento}
                  onChange={handleChangePrazo}
                  {...prazoPagamentoSelect}
                />

                <div className="flex items-center gap-x-4">
                  <InputField
                    labelName="Início:"
                    inputName="dataInicioVigencia"
                    as={MaskedInput}
                    mask={dateMask}
                    errors={errors.dataInicioVigencia}
                    touched={touched.dataInicioVigencia}
                    inputMask="onmask"
                    inputType="text"
                    onChangeEvent={handleChangeDates}
                  />

                  <InputField
                    labelName="Fim:"
                    inputName="dataFimVigencia"
                    as={MaskedInput}
                    mask={dateMask}
                    errors={errors.dataFimVigencia}
                    touched={touched.dataFimVigencia}
                    inputMask="onmask"
                    inputType="text"
                    onChangeEvent={handleChangeDates}
                  />
                </div>

                <Select
                  name="motivoId"
                  label={<>Informe o <b className="px-[.2rem]">Motivo</b> das negociações solicitadas:</>}
                  placeholder=""
                  options={optionMotivos}
                  noOptionsMessage="Motivo não encontrado"
                  onChange={(e) => onChangeMotivo(e)}
                  errors={errors.motivoId}
                  touched={touched.motivoId}
                  {...motivoSelect}
                />

                <Field name="justificativa">
                  {({ field, form }) => (
                    <FormControl isInvalid={form.errors.justificativa && form.touched.justificativa}>
                      <FormLabel className="field__label">
                        Informe a <b>Justificativa</b> das negociações solicitadas:
                      </FormLabel>
                      <Textarea
                        {...field}
                          maxLength={maxlenght}
                          onInput={(e) => setCaracteres(e.target.value)}
                      />
                      <div className="flex justify-end w-full">
                        <p className="opacity-40 px-1 desc">{caracteres.length}/{maxlenght}</p>
                      </div>
                      <FormErrorMessage>{form.errors.justificativa}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </div>
              {loading && (
                <>
                  <div className="spinner__form ">
                    <Loader />
                  </div>
                </>
              )}
              <button
                className="button-search flex justify-center items-center py-3 px-6 mt-4 ml-auto bg-secundaria text-primaria hover:text-white hover:bg-primaria rounded-lg gap-1 font-bold text-lg "
                type="submit"
                disabled={loading}
              >
                Enviar para aprovação
              </button>
            </div>
            <div className={overlayClasses} onClick={onClose}></div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
export default ModalInfosAdicionais;